<template>
    <!-- ========== HEADER ========== -->
    <header class="fixed header-animation" v-bind:class="{ 'transparent' : transparent }">
        <div class="container">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle mobile_menu_btn" data-toggle="collapse" data-target=".mobile_menu" aria-expanded="false">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <router-link to="/" style="margin-top:0;padding: 5px 0;" class="navbar-brand" href="index.html" v-bind:class="{ 'light' : transparent }" v-if="transparent">
                    <img src="/assets/ceo/logo_hotel_white.png" height="60" alt="Logo">
                </router-link>
                <router-link to="/" style="margin-top:0;padding: 5px 0;" class="navbar-brand " href="index.html" v-bind:class="{ 'dark nodisplay' : transparent }">
                    <img src="/assets/ceo/logo_hotel.png" height="45" alt="Logo">
                </router-link>
            </div>
            <nav id="main_menu" class="mobile_menu navbar-collapse">
                <ul class="nav navbar-nav">
                    <li class="mobile_menu_title" style="display:none;" v-lang.menu></li>
                    <li> <router-link to="/" v-lang.inicio></router-link></li>
                    <li> <router-link to="/site/rooms" v-lang.habitaciones></router-link></li>
                    <li><router-link to="/site/contact" v-lang.contacto></router-link></li>
                    <li><router-link to="/site/blog" v-lang.blog></router-link></li>
                    <li class="menu_button">
                        <!--<router-link to="/site/book" class="button btn_yellow">
                            <i class="fa fa-calendar"></i> <span v-lang.book></span>
                        </router-link>-->
                        <a class="button btn_yellow" @click.stop.prevent="showAlert">
                            <i class="fa fa-calendar"></i> <span v-lang.book></span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </header>
</template>

<script>
    export default {
        props : {
            transparent : {
                type : Boolean,
                default : true
            }
        },
        created : function(){
            var self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
            });
        },
        beforeDestroy : function(){
            this.unsubscribe();
        },
        methods: {
            showAlert() {
              alert('Esta funcionalidad aún no está disponible. Por favor utilice el formulario de contacto.');
            },
        },
    }
</script>

<style lang="scss">
    .header-animation
    {
        transition: all 1s ease;
    }
</style>


// WEBPACK FOOTER //
// HeaderTransparent.vue?15ac5690